export default __webpack_public_path__ + "static/media/info-grey.6446e0fb.svg";